import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../siteadmin/AdminFooter';
import SideBar from '../siteadmin/SideBar';
import history from '../../core/history';
import { checkGlobalLogout, removeCookies } from '../../helpers/cookies';
import { setRuntimeVariable } from '../../actions/runtime';
import Toaster from '../Toaster/Toaster';
import OffcanvasMenu from '../siteadmin/SideBar/MobileSideBar/OffcanvasMenu';
import s from './AdminLayout.css';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    isAdminAuthenticated: PropTypes.bool,
    setRuntimeVariable: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      processingLogout: false,
    };
    this.lastLogoutCheck = '0';
    this.lastLogoutId = null;
  }

  componentDidMount() {
    this.setupLogoutListener();
  }

  componentWillUnmount() {
    this.removeLogoutListener();
  }

  setupLogoutListener = () => {
    // Check if there's a pending logout
    this.checkForLogout();

    // Verify cookie exists on each page render
    this.verifyCookieExists();

    // Set up storage event listener
    if (typeof window !== 'undefined') {
      // Listen for storage events (both localStorage and sessionStorage)
      window.addEventListener('storage', this.handleStorageChange);

      // Also set up an interval check as a backup
      this.logoutInterval = setInterval(() => {
        this.checkForLogout();
        this.verifyCookieExists();
      }, 1000); // Check every second for more reliability
    }
  }

  removeLogoutListener = () => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('storage', this.handleStorageChange);

      if (this.logoutInterval) {
        clearInterval(this.logoutInterval);
      }
    }
  }

  handleStorageChange = (e) => {
    // If any of our logout indicators changed in storage
    if (e.key === 'admin_global_logout' || e.key === 'admin_logout_id') {
      this.checkForLogout();
    }
  }

  // Verify the auth cookie exists, if not, trigger logout
  verifyCookieExists = () => {
    const { isAdminAuthenticated } = this.props;

    if (isAdminAuthenticated && !this.state.processingLogout && typeof document !== 'undefined') {
      // Check if id_token cookie exists
      const hasCookie = document.cookie.split(';').some(item => {
        return item.trim().startsWith('id_token=');
      });

      if (!hasCookie) {
        console.log('Auth cookie missing, triggering logout');
        this.setState({ processingLogout: true }, () => {
          this.performLogout();
        });
      }
    }
  }

  checkForLogout = () => {
    // Skip if we're already processing a logout or not authenticated
    const { isAdminAuthenticated } = this.props;
    if (!isAdminAuthenticated || this.state.processingLogout) {
      return;
    }

    try {
      
    } catch (error) {
      console.error('Error in checkForLogout:', error);
    }
  }

  performLogout = () => {
    try {
      const { setRuntimeVariable } = this.props;

      console.log('Performing logout');

      // Clear cookies
      removeCookies({ name: 'id_token' });

      // Update Redux state
      setRuntimeVariable({
        name: 'isAdminAuthenticated',
        value: false
      });

      // To prevent endless reloading or multiple redirects,
      // check the current URL before redirecting
      if (typeof window !== 'undefined') {
        const currentPath = window.location.pathname;
        if (!currentPath.includes('/siteadmin/login')) {
          // Store a flag in sessionStorage to indicate we're redirecting
          // This helps prevent loops during page transitions
          window.sessionStorage.setItem('admin_redirecting_to_login', 'true');

          // Force a hard reload to the login page to ensure clean state
          const timestamp = Date.now();
          const randomParam = Math.random().toString(36).substring(2, 8);
          // window.location.href = `/siteadmin/login?t=${timestamp}&r=${randomParam}`;
        }
      }
    } catch (error) {
      console.error('Error during logout:', error);

      // In case of error, try the most direct approach
      // if (typeof window !== 'undefined') {
      //   window.location.href = '/siteadmin/login';
      // }
    }
  }

  render() {
    let location;
    if (history.location) {
      location = history.location.pathname
    }

    return (
      <div className="adminstyle">
        <Toaster />
        <AdminHeader />
        <aside className={cx(s.sideMenuContainer, 'printViewNone')}>
          <div className={cx(s.sideMenuWrapper, 'sideMenuWrapperRtl')}>
            <SideBar location={location} changeLocation={this.changeLocation} />
          </div>
        </aside>
        <OffcanvasMenu location={location} />
        <div className={cx(s.sideAdminPageWrapper, ' sideAdminPageWrapperRtl')}>{this.props.children}</div>
        <AdminFooter />
      </div>
    );
  }
}

const mapState = (state) => ({
  isAdminAuthenticated: state.runtime.isAdminAuthenticated
});

const mapDispatch = {
  setRuntimeVariable
};

export default connect(mapState, mapDispatch)(withStyles(s)(Layout));
